import { AddressType } from '../../shared/models/enums/addressType.enum';

export class BeneficiaryAddressDto {
  public id?: number;
  public address: string;
  public beginDate: Date;
  public endDate?: Date;
  public additionalAddress?: string;
  public postalCode: string;
  public city: string;
  public cliId?: number;
  public cliLabel?: string;
  public ctmId?: number;
  public ctmLabel?: string;
  public qpvId?: number;
  public qpvLabel?: string;
  public residentialStatus?: string;
  public residentialStatusComplement?: string;
  public domiciliationType?: string;
  public domiciliationTypeComplement?: string;
  public beneficiaryId?: number;
  public historized?: boolean;
  public addressType: AddressType;

  public static fromJson(json: any): BeneficiaryAddressDto {
    const dto: BeneficiaryAddressDto = new BeneficiaryAddressDto();
    dto.id = json.id;
    dto.address = json.address;
    dto.beginDate = json.beginDate ? new Date(json.beginDate) : undefined;
    dto.endDate = json.endDate ? new Date(json.endDate) : undefined;
    dto.additionalAddress = json.additionalAddress;
    dto.postalCode = json.postalCode;
    dto.city = json.city;
    dto.cliId = json.cliId;
    dto.cliLabel = json.cliLabel;
    dto.ctmId = json.ctmId;
    dto.ctmLabel = json.ctmLabel;
    dto.qpvId = json.qpvId;
    dto.qpvLabel = json.qpvLabel;
    dto.residentialStatus = json.residentialStatus;
    dto.residentialStatusComplement = json.residentialStatusComplement;
    dto.domiciliationType = json.domiciliationType;
    dto.domiciliationTypeComplement = json.domiciliationTypeComplement;
    dto.beneficiaryId = json.beneficiaryId;
    dto.historized = json.historized;
    dto.addressType = json.addressType;
    return dto;
  }
}
